import { render, staticRenderFns } from "./ProvideProfileDetailsModal.vue?vue&type=template&id=56890810"
import script from "./ProvideProfileDetailsModal.vue?vue&type=script&lang=ts"
export * from "./ProvideProfileDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./ProvideProfileDetailsModal.vue?vue&type=style&index=0&id=56890810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports